export enum EActions {
  SigninSuccess = 'SigninSuccess',
  OrganizationSuccess = 'OrganizationSuccess',
  OrganizationSwitch = 'OrganizationSwitch',
  OrganizationUsers = 'OrganizationUsers',
  OrganizationUsersSuccess = 'OrganizationUsersSuccess',
  OrganizationUsersFail = 'OrganizationUsersFail',

  ChangeEmail = 'ChangeEmail',
  ChangeEmailSuccess = 'ChangeEmailSuccess',
  ChangeEmailFail = 'ChangeEmailFail',

  NewPassword = 'NewPassword',
  NewPasswordSuccess = 'NewPasswordSuccess',
  NewPasswordFail = 'NewPasswordFail',

  MeSuccess = 'MeSuccess',
  MeFail = 'MeFail',

  UpdateMe = 'UpdateMe',
  UpdateMeSuccess = 'UpdateMeSuccess',
  UpdateMeFail = 'UpdateMeFail',

  GetContacts = 'GetContacts',
  GetContactsSuccess = 'GetContactsSuccess',
  GetContactsFail = 'GetContactsFail',

  SaveContacts = 'SaveContacts',
  SaveContactsSuccess = 'SaveContactsSuccess',
  SaveContactsFail = 'SaveContactsFail',

  DeleteContacts = 'DeleteContacts',
  DeleteContactsSuccess = 'DeleteContactsSuccess',
  DeleteContactsFail = 'DeleteContactsFail',

  ContactsCleanUp = 'ContactsCleanUp',

  GetShifts = 'GetShifts',
  GetShiftsSuccess = 'GetShiftsSuccess',
  GetShiftsFail = 'GetShiftsFail',
  GetShift = 'GetShift',
  GetShiftSuccess = 'GetShiftSuccess',
  GetShiftFail = 'GetShiftFail',
  SaveShifts = 'SaveShifts',
  SaveShiftsSuccess = 'SaveShiftsSuccess',
  SaveShiftsFail = 'SaveShiftsFail',
  DeleteShifts = 'DeleteShifts',
  DeleteShiftsSuccess = 'DeleteShiftsSuccess',
  DeleteShiftsFail = 'DeleteShiftsFail',
  ShiftsCleanUp = 'ShiftsCleanUp',
  ShiftsReset = 'ShiftsReset',

  GetInvoices = 'GetInvoices',
  GetInvoicesSuccess = 'GetInvoicesSuccess',
  GetInvoicesFail = 'GetInvoicesFail',
  GetInvoice = 'GetInvoice',
  GetInvoiceSuccess = 'GetInvoiceSuccess',
  GetInvoiceFail = 'GetInvoiceFail',
  SaveInvoices = 'SaveInvoices',
  SaveInvoicesSuccess = 'SaveInvoicesSuccess',
  SaveInvoicesFail = 'SaveInvoicesFail',
  DeleteInvoices = 'DeleteInvoices',
  DeleteInvoicesSuccess = 'DeleteInvoicesSuccess',
  DeleteInvoicesFail = 'DeleteInvoicesFail',
  InvoicesCleanUp = 'InvoicesCleanUp',

  GetExpenses = 'GetExpenses',
  GetExpensesSuccess = 'GetExpensesSuccess',
  GetExpensesFail = 'GetExpensesFail',
  SaveExpenses = 'SaveExpenses',
  SaveExpensesSuccess = 'SaveExpensesSuccess',
  SaveExpensesFail = 'SaveExpensesFail',
  DeleteExpenses = 'DeleteExpenses',
  DeleteExpensesSuccess = 'DeleteExpensesSuccess',
  DeleteExpensesFail = 'DeleteExpensesFail',
  ExpensesCleanUp = 'ExpensesCleanUp',

  GET_ONE = 'GET_ONE',
  GET_ONE_SUCCESS = 'GET_ONE_SUCCESS',
  GET_ONE_FAIL = 'GET_ONE_FAIL',

  GET_RECIPIENTS = 'GET_RECIPIENTS',
  GET_RECIPIENTS_SUCCESS = 'GET_RECIPIENTS_SUCCESS',
  GET_RECIPIENTS_FAIL = 'GET_RECIPIENTS_FAIL',

  CRUD_BEGIN_EDIT = 'CRUD_BEGIN_EDIT',
  CRUD_END_EDIT = 'CRUD_END_EDIT',
  CRUD_CLEANUP = 'CRUD_CLEANUP',
  CRUD_TOGGLE_FILTER = 'CRUD_TOGGLE_FILTER',
  CRUD_LOADING = 'CRUD_LOADING',

  CRUD_GET_DROPDOWN = 'CRUD_GET_DROPDOWN',
  CRUD_GET = 'CRUD_GET',
  CRUD_REPLACE = 'CRUD_REPLACE',
  CRUD_GET_FAIL = 'CRUD_GET_FAIL',
  CRUD_GET_SUCCESS = 'CRUD_GET_SUCCESS',

  NOTIFY = 'NOTIFY',
  NOTIFY_SUCCESS = 'NOTIFY_SUCCESS',
  NOTIFY_FAIL = 'NOTIFY_FAIL',
  NOTIFY_CLEANUP = 'NOTIFY_CLEANUP',

  CRUD_SAVE = 'CRUD_SAVE',
  CRUD_SAVE_SUCCESS = 'CRUD_SAVE_SUCCESS',
  CRUD_SAVE_FAIL = 'CRUD_SAVE_FAIL',

  CRUD_DELETE = 'CRUD_DELETE',
  CRUD_DELETE_FAIL = 'CRUD_DELETE_FAIL',

  GetExpensesAttachments = 'GetExpensesAttachments',
  ClearExpensesAttachments = 'ClearExpensesAttachments',

  PAYMENT = 'PAYMENT',
  PAYMENT_SUCCESS = 'PAYMENT_SUCCESS',
  PAYMENT_FAIL = 'PAYMENT_FAIL',
}
